import { useState, useEffect, useContext } from "react";
import ReportContext, { Types } from "../../../context/ReportsContext/ReportContext";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

const FilesTable = ({ type, name, label, setAddTxt, width, onChange, value }: any) => {
  const { state, dispatch } = useContext(ReportContext);
  const [input, setInput] = useState(value || "");

  // Maneja cambios en el input
  const handleChange = (e: any) => {
    const { value } = e.target;
    setInput(value);
    setAddTxt(true);
    onChange(e);

    // Actualiza estado global inpuntValues
    dispatch({
      type: Types.INPUT_VALUES,
      payload: { [name]: value },
    });
  };

  useEffect(() => {
    if (
      state?.reportPreviewData?.reload === true || 
      (Array.isArray(state?.reportPreviewData?.inpuntValues) &&
        state?.reportPreviewData?.inpuntValues.length === 0)
    ) {
      setInput("");

      if (state?.reportPreviewData?.reload === true) {
        dispatch({
          type: Types.LOAD_DATA_REPORT,
          payload: {
            ...state.reportPreviewData,
            reload: false,
          },
        });
      }
    }
  }, [state?.reportPreviewData?.reload, state?.reportPreviewData?.inpuntValues]);
 
  const handleEliminar = () => {    
    setInput("");    
    dispatch({
      type: Types.INPUT_VALUES,
      payload: Object.fromEntries(
        Object.entries(state.reportPreviewData.inpuntValues || {}).filter(
          ([key]) => key !== name
        )
      ),
    });
  };

  return (
    <div className="containerComponentReport">
      <label className="labelReport">{label}</label>
      <div className="containerInputReport">
        <input
          className="inputInformes"
          type={type}
          id={name}
          name={name}
          width={width}
          value={input}
          onChange={handleChange}
        />
        <DeleteOutlineIcon
          className="deleteReport"
          sx={{ color: "#E0544B" }}
          onClick={handleEliminar}
        />
      </div>
    </div>
  );
};

export default FilesTable;
